import { TranslocoPipe, provideTranslocoScope } from '@jsverse/transloco';
import { Component, inject } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { CustomersNotificationsBottomSheet } from 'customers';
import { OrderProposalService } from '../../services/order-proposal.service';

// Anomalie del cliente della proposta, dagli alert della risposta come nella scheda cliente
@Component({
  providers: [provideTranslocoScope('orders')],
  selector: 'ord-proposal-anomalies',
  imports: [TranslocoPipe, MatButtonModule],
  template: `
    @if (alerts().length > 0) {
      <div class="anomalies-row">
        <i class="fa-solid fa-triangle-exclamation anomalies-icon"></i>
        <span class="body-medium anomalies-text">{{ 'orders.ui.sonoPresentiDelleAnomalie' | transloco }}</span>
        <button matButton type="button" class="anomalies-action" (click)="openAlerts()">{{ 'orders.ui.scopriDiPiu' | transloco }}</button>
      </div>
    }
  `,
  styles: `
    .anomalies-row {
      display: flex;
      align-items: center;
      gap: var(--mat-sys-spacing-8);
    }

    .anomalies-icon {
      color: var(--mat-sys-warning);
    }

    .anomalies-text {
      flex: 1 1 auto;
      color: var(--mat-sys-on-surface);
    }

    .anomalies-action {
      text-decoration: underline;
    }
  `,
})
export class ProposalAnomalies {
  private readonly bottomSheet = inject(MatBottomSheet);
  readonly alerts = inject(OrderProposalService).customerAlerts;

  openAlerts(): void {
    this.bottomSheet.open(CustomersNotificationsBottomSheet, { data: { notifications: this.alerts() } });
  }
}
